import React, { useCallback } from "react";
import { Checkbox, FormControlLabel, Grid, TextField } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../store";
import { setPreferencesPartial } from "../../store/expertise/expertise.reducer";
import { NonNegativeIntegerValidator } from "../../../core/validators/non.negative.integer.validator";

export default function QuotaMaxTle() {
	const dispatch = useAppDispatch();
	const { preferences, user } = useAppSelector((s) => ({
		preferences: s.expertise.preferences,
		user: s.auth.user,
	}));
	const dailyTeleExpertiseLimitEnabled = preferences?.preferencesRestriction?.dailyTeleExpertiseLimitEnabled ?? false;
	const maxTlePerDay = preferences?.preferencesRestriction?.maxTlePerDay;

	const setDailyTeleExpertiseLimitEnabled = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			dispatch(
				setPreferencesPartial({
					preferencesRestriction: {
						dailyTeleExpertiseLimitEnabled: e.target.checked,
					},
				})
			);
		},
		[dispatch]
	);

	const setMaxTlePerDay = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			dispatch(
				setPreferencesPartial({
					preferencesRestriction: {
						maxTlePerDay: parseInt(e.target.value, 10),
					},
				})
			);
		},
		[dispatch]
	);

	if (!preferences || !user) return null;

	const isInputInvalid = dailyTeleExpertiseLimitEnabled && !NonNegativeIntegerValidator.validate(maxTlePerDay);

	return (
		<Grid container direction={"column"}>
			<Grid item>
				<FormControlLabel
					control={<Checkbox id={"daily-tle-limit-enabled"} checked={dailyTeleExpertiseLimitEnabled} onChange={setDailyTeleExpertiseLimitEnabled} />}
					label={"Limiter le nombre de demandes de téléexpertise reçues par jour"}
				/>
			</Grid>
			{dailyTeleExpertiseLimitEnabled && (
				<Grid item marginLeft={4} marginTop={0.5}>
					<Grid container alignItems="center" wrap="nowrap" spacing={1}>
						<Grid item>Accepter au maximum</Grid>
						<Grid item>
							<TextField
								key={user!.idTechPs}
								variant="standard"
								type="number"
								inputProps={{
									style: { width: "60px", textAlign: "center" },
									min: 0,
								}}
								error={isInputInvalid}
								onChange={setMaxTlePerDay}
								value={maxTlePerDay}
							/>
						</Grid>
						<Grid item>demandes par jour</Grid>
					</Grid>
				</Grid>
			)}
		</Grid>
	);
}
